export default {
  title: "Tum Devextreme Vue App 2"
};
